/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */

import { didomiIsEnabled } from "./globalConfig"
import {
  updateDeviceIdPersistenceConsent,
  startObservingConsentStatusChange,
  updateConsentStatus,
} from "@theconversation/shared-libraries/tcEventsCollector"

// This must be called to initialise the Didomi callbacks when the status changes.
let tcEventGdprConsentStatusSetupComplete: boolean = false

export function setupTcEventGdprConsentStatus() {
  if (tcEventGdprConsentStatusSetupComplete) return

  // If Didomi isn't even enabled, default to true
  if (!didomiIsEnabled()) {
    updateDeviceIdPersistenceConsent(true)
    return
  }

  updateConsentStatus() // Get the initial status
  startObservingConsentStatusChange() // Watch for changes

  tcEventGdprConsentStatusSetupComplete = true
}
